import React, { ReactElement } from 'react';
import './tableFilterList.module.scss';

type Props = {
  children: ReactElement[] | ReactElement;
};
export const TableFilterList = ({ children }: Props) => {
  return <div styleName="table-filter-list">{children}</div>;
};
